<template>
  <base-material-card class="v-card--material-chart" v-bind="$attrs" v-on="$listeners">
    <GChart
      :settings="{ packages: ['corechart'] }"
      :data="processedChartData"
      :options="chartOptions"
      :createChart="createChart"
      @ready="onChartReady"
    />

    <slot />

    <slot slot="actions" name="actions" />
  </base-material-card>
</template>

<script>
import _ from 'lodash';

import colors from '@/utils/colors';

export default {
  inheritAttrs: false,
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    showTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      chartLibrary: null,
      chart: null,
    };
  },
  computed: {
    processedChartData() {
      if (!this.chartLibrary || !this.chart) return [];
      const theData = _.clone(this.chartData);
      const dataTable = new this.chartLibrary.visualization.DataTable();

      const headerRow = theData.shift();
      dataTable.addColumn('date', headerRow.shift());
      if (_.isEmpty(headerRow)) {
        headerRow.push('Empty');
      }
      headerRow.forEach((value) => {
        dataTable.addColumn('number', value);
      });
      dataTable.addRows(
        theData.map((row) => {
          row[0] = new Date(row[0]);
          return row;
        }),
      );

      return dataTable;
    },
    chartOptions() {
      if (!this.chartLibrary) return null;
      return {
        seriesType: 'bars',
        series: {
          0: { color: colors[0], type: 'bars' },
          1: { color: colors[1], type: 'area' },
          2: { color: colors[2], type: 'area' },
          3: { color: colors[3], type: 'area' },
        },
        height: 380,
      };
    },
  },
  methods: {
    onChartReady(chart, google) {
      this.chartLibrary = google;
      this.chart = chart;
    },
    createChart(el, google) {
      return new google.visualization.ComboChart(el);
    },
  },
};
</script>

<style lang="scss">
.v-card--material-chart {
  padding-top: 2em;
  .v-card--material__header {
    padding: 2em 0;
  }
}
</style>
